exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-e65717c8] {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  background: white;\n  z-index: 1;\n}\n#base-file-list[data-v-e65717c8] {\n  min-height: 300px;\n}\n#loading-block[data-v-e65717c8] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 300px;\n}", ""]);

// exports
